// extracted by mini-css-extract-plugin
module.exports = {"bag":"Bag_bag__IMbC4","highlighted":"Bag_highlighted__NJzlt"};